<script setup lang="ts">
const { count, latest, wishlist } = useWishlist()
const { addToWishList, removeFromWishList } = useDataLayer()

watch(latest, async () => {
  const isInWishlist = computed(() =>
    wishlist.value.some(item => item.sku === latest.value?.sku),
  )
  const result = await useGraphqlQuery('wishlistProduct', {
    sku: latest.value?.sku,
  }, useGraphqlDefaultClient())

  if (!isInWishlist.value) {
    removeFromWishList(result.data?.product, {
      sku: latest.value?.sku,
      quantity: 1,
    })
  }
  else {
    addToWishList(result.data?.product, {
      sku: latest.value?.sku,
      quantity: 1,
    })
  }
})
</script>

<template>
  <div class="mini-wishlist">
    <AppLink
      to="/wishlist/"
      class="mini-wishlist__link"
      :aria-label="$t('My wishlist')"
    >
      <NuxtIcon :name="'icon:heart-empty'" />
      <span
        v-if="count"
        class="mini-wishlist__amount"
      >
        {{ count }}
      </span>
      <span class="mini-wishlist__label">
        {{ $t('My wishlist') }}
      </span>
    </AppLink>
  </div>
</template>

<style>
@import url("~layers/components/Header/Wishlist.css");
</style>
